import React from 'react';

import color from '@/core/features/styles/color';

export type HtmlTextWrapperProps = {
    className?: string;
    htmlText: string;
    inline?: boolean;
    style?: React.CSSProperties;
};

export default function HtmlTextWrapper({ className, htmlText, inline = false, style }: HtmlTextWrapperProps) {
    const elementType = inline ? 'span' : 'div';
    return (
        <>
            {React.createElement(elementType, {
                className: `htmlTextWrapper inline ${className ?? ''}`,
                dangerouslySetInnerHTML: { __html: htmlText },
                style: {
                    ...style,
                    display: className?.includes('line-clamp-') ? '-webkit-box' : undefined,
                },
            })}
            <HtmlTextWrapperStyles />
        </>
    );
}

export function HtmlTextWrapperStyles() {
    return (
        <style
            global
            jsx
        >{`
            .htmlTextWrapper {
                display: inline;
            }

            .htmlTextWrapper p,
            .htmlTextWrapper ol,
            .htmlTextWrapper ul {
                margin-bottom: 10px;
            }

            .htmlTextWrapper p:last-child,
            .htmlTextWrapper ol:last-child,
            .htmlTextWrapper ul:last-child {
                margin-bottom: 0;
                display: inline;
            }

            .htmlTextWrapper ul {
                line-height: 20px;
                list-style-type: disc;
                padding-left: 0;
            }

            .htmlTextWrapper li {
                margin-left: 40px;
            }

            .htmlTextWrapper ol {
                line-height: 20px;
                list-style-type: decimal;
                padding-left: 0;
            }

            .htmlTextWrapper em {
                font-style: italic;
            }

            .htmlTextWrapper strong {
                font-weight: bold;
            }

            .htmlTextWrapper u {
                text-decoration: underline;
            }

            .htmlTextWrapper a {
                color: ${color('endeavour')};
                cursor: pointer;
            }
            .htmlTextWrapper a:hover {
                color: ${color('roseOfSharon')};
                text-decoration: underline;
            }
        `}</style>
    );
}
